exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media (max-width:767px){#about-view #tab-selector-base.tab-selector[selected=corporate-governance],#about-view #tab-selector-base.tab-selector[selected=team]{width:50%}#about-view #tab-selector-base.tab-selector[selected=corporate-governance] .mdl-tabs__tab,#about-view #tab-selector-base.tab-selector[selected=team] .mdl-tabs__tab{border-right:1px solid #e0e0e0}#about-view #tab-selector-base.tab-selector[selected=corporate-governance] .tab-select-icon,#about-view #tab-selector-base.tab-selector[selected=team] .tab-select-icon{right:12px}#about-view #about-view-content{margin-top:53px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js!./~/sass-loader!./~/vue-loader/lib/selector.js?type=style&index=0!./assets/component/about/about-page.vue
// module id = 271
// module chunks = 0